<template>
    <fragment>
        <light-header></light-header>
        <div class="sm-container">
            <div class="sep-32"></div>
            <div class="title-lg">
                Start a new valuation
            </div>
            <div class="sep-16"></div>
            <div class="detailed-valuation">
                <div class="title-sm ">
                    Detailed Valuation
                </div>
                <div class="sep-16"></div>
                <div>
                    Start filling the questionnaire to describe your startup and get a detailed valuation using four
                    methods, along with industry and country statistics and a downloadable report.
                </div>
                <div class="sep-16"></div>
                <router-link :to="{'name': 'calculator'}" class="button is-primary">
                    Start Now
                </router-link>
            </div>
            <div class="sep-32"></div>
            <div class="industry-valuation">
                <div class="title-sm ">
                    Industry and Country Statistics
                </div>
                <div class="sep-16"></div>
                <div>
                    Choose the industry and country you're interested in to get related industry and country statistics.
                </div>
                <div class="sep-16"></div>
                <div v-if="subscriptionDetails && subscriptionDetails.has_real_credits">
                    <router-link :to="{'name': 'ics_calculator'}">
                        Start Now
                    </router-link>
                </div>
                <div v-if="subscriptionDetails && !subscriptionDetails.has_real_credits">
                   <router-link :to="{'name':'plans'}" class="button is-primary">
                        Upgrade
                   </router-link>
                </div>
            </div>
        </div>
    </fragment>
</template>

<script>
    import LightHeader from "../../../shared/components/LightHeader";
    import {config} from "@/config/config";

    export default {
        name: "NewValuation.vue",
        components: {
            LightHeader
        },
        data(){
            let plansPricing = config('HOMEPAGE') + 'plans-pricing';
            return {
              plansPricing: plansPricing
            }
        },
        async mounted() {
          await this.$store.dispatch('account/updateSubscriptionDetails');
        },
        computed:{
           subscriptionDetails(){
                return this.$store.state.account.subscriptionDetails;
           }
        }
    }
</script>

<style lang="scss" scoped>
    .detailed-valuation {
        background-color: #E9F8F9;
        border: 1px solid #D2F2F1;
        padding: 16px;
        border-radius: 4px;
    }

    .industry-valuation{
        background-color: #fff;
        border: 1px solid #D2F2F1;
        padding: 16px;
        border-radius: 4px;
    }
</style>
